module.exports = __webpack_public_path__ + "static/jade-vincent-55964604c533b61c3a2d6bea4acb4421.jpg";